import axios from 'axios'

export default {
  getZones: ({ commit, dispatch, rootState }) => {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getZones', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(`${process.env.VUE_APP_URL}/adminapi/zones`, config)
        .then(response => {
          const zones = response.data
          commit('setZones', zones)
          resolve()
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getZones', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject()
        })
    })
  },
  /**
   * Gets and sets zone by campaign id
   * @param {Number} id
   */
  getZone: async ({ commit, dispatch, rootState }, id) => {
    commit('app/setLoading', { type: 'getZone', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/zones/${id}`, config)
        .then(response => {
          commit('setZone', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getZone', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  saveZone: async ({ commit, rootState }, payload) => {
    commit('app/setLoading', { type: 'saveZone', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      const url = `${process.env.VUE_APP_URL}/adminapi/zones`
      let type = ''
      let messageKey
      const { zone, icon } = payload

      if (zone.ID > 0) {
        await axios.put(url, zone, config).then(response => {
          commit('updateZone', response.data)
          messageKey = 'ZONE_UPDATED'
        })
      } else {
        await axios.post(url, zone, config).then(response => {
          commit('addZone', response.data)
          type = 'saveZone'
          messageKey = 'NEW_ZONE_ADDED'
        })
      }

      if (icon) {
        const data = new FormData()
        data.append('icon', icon.result)
        await axios.post(
          `${url}/icon`,
          {
            base64EncodedImage: icon,
            fileName: zone.Name.toUpperCase()
          },
          config
        )
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'success',
          message: this.$vuetify.lang.t(`$vuetify.SETTINGS.${messageKey}`)
        },
        { root: true }
      )
      commit('app/setLoading', { type, state: false }, { root: true })
      commit('app/setError', null, { root: true })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
        },
        { root: true }
      )
      commit('app/setLoading', { type: '', state: false }, { root: true })
      commit('app/setError', error, { root: true })
    }
  },
  deleteZone: ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'deleteZone', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .delete(`${process.env.VUE_APP_URL}/adminapi/zones`, {
          headers: config.headers,
          data: payload
        })
        .then(() => {
          commit('removeZone', payload.ID)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'deleteZone', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  }
}
